// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Vetff","title":"Header_title__87Ruw","rightContainer":"Header_rightContainer__Po5GB"};